<template>
	<div></div>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	mounted() {
		window.addEventListener('message', this.setUser); //message에 대한 이벤트 리스너(타 시스템 접속 계정 수신) 등록
	},

	beforeDestroy() {
		window.removeEventListener('message', this.setUser); //message에 대한 이벤트 리스너(타 시스템 접속 계정 수신) 삭제
	},

	computed: {
		...rootComputed
	},

	methods: {
		...rootMethods,

		setUser(e) {
			if (e.data.message === 'sendUser') {
				//message가 sendUser 맞으면
				const { userId, userPw } = e.data; //타 시스템 접속 계정
				const { langCd = '', scrId = '' } = this.$route.query;

				if (langCd) {
					this.getLangMessage(langCd);
				}

				this.directLogin(userId, userPw, langCd, scrId);
			}
		},

		//query String의 언어 정보를 이용해 다국어 리스트 요청
		getLangMessage(langCd) {
			this.$sf_toggleLoading(true);

			//다국어 리스트를 요청하는 Action 호출
			this.getLangMessage_({ langCd })
				.then(header => {
					//실패 시에만 에러 toast 창 알림
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//Direct Login 호출
		directLogin(userId, userPw, langCd, scrId) {
			this.$sf_toggleLoading(true);

			this.directLogin_({ userId, userPw, langCd, scrId })
				.then(header => {
					//실패 시에만 에러 toast 창 알림
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					} else {
						//해당 URL로 redirect
						window.location.href = header.redirectUrl;
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
<style></style>
